import { render, staticRenderFns } from "./certificationAuditList.vue?vue&type=template&id=27a21c56&scoped=true&"
import script from "./certificationAuditList.vue?vue&type=script&lang=js&"
export * from "./certificationAuditList.vue?vue&type=script&lang=js&"
import style0 from "./certificationAuditList.vue?vue&type=style&index=0&id=27a21c56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a21c56",
  null
  
)

export default component.exports